import * as React from 'react';

import { TooltipWrapper } from '@coursera-web/cds-labs';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import { color } from '@coursera/coursera-ui';
import { SvgFlashFilled, SvgHelp } from '@coursera/coursera-ui/svg';

import { getReadableConfidenceLevel } from 'bundles/asset-admin/utils/AutoGeneratedTagUtils';

import _t from 'i18n!nls/asset-admin';

import 'css!./__styles__/AutoGeneratedImageAssetPageTag';

type InputProps = {
  confidenceLevel?: number;
};

const AutoGeneratedImageAssetPageTag: React.FC<InputProps> = ({ confidenceLevel }) => {
  const readableConfidenceLevel = getReadableConfidenceLevel(confidenceLevel);

  return (
    <div className="rc-AutoGeneratedImageAssetPageTag">
      <span className="flash-icon">
        <SvgFlashFilled size={16} />
      </span>
      <Typography2 component="p" variant="bodySecondary" className="auto-gen-accuracy-label">
        <FormattedMessage
          message={_t('Auto-generated with {confidenceLevel}% accuracy')}
          confidenceLevel={readableConfidenceLevel}
        />
      </Typography2>
      <span className="help-icon">
        <TooltipWrapper
          tooltipId="auto-generated-accurary-level"
          message={_t(
            'Machine learning is used to recognize what appears in your image assets. Edit this accessibility setting for all your images in accessibility settings.'
          )}
          placement="right"
        >
          <SvgHelp suppressTitle={true} size={12} color={color.primaryText} />
        </TooltipWrapper>
      </span>
    </div>
  );
};

export default AutoGeneratedImageAssetPageTag;
